import s from "./NotFoundPage.module.css";

const NotFoundPage = () => {
  return (
    <div className={s.container}>
      <h2>404 Page not found 😢</h2>
    </div>
  );
};
export default NotFoundPage;
